export default __webpack_public_path__ + "static/media/v11.f27fae63.svg";